import React, { useEffect, useState } from 'react';
import Gallery from '../components/Gallery';
import SearchBar from '../components/SearchBar';
import { fetchImages, fetchTotalCount } from '../services/api';

type ImageMeta = {
  filename: string;
  tags: string[];
  url?: string;
};

const Home: React.FC = () => {
    const [images, setImages] = useState<ImageMeta[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [searchTag, setSearchTag] = useState('');
    const [totalCount, setTotalCount] = useState<number | null>(null);
    const [taggedCount, setTaggedCount] = useState<number | null>(null);

    useEffect(() => {
        const loadImages = async () => {
            try {
                const fetched: any = await fetchImages();
                // normalize possible response shapes without using `??` (older parsers may not support it)
                let list: ImageMeta[] = [];
                if (Array.isArray(fetched)) {
                    list = fetched;
                } else if (fetched && (fetched.items || fetched.images)) {
                    list = fetched.items || fetched.images;
                } else if (fetched) {
                    list = fetched;
                }
                setImages(list);
            } catch (err) {
                console.log('Failed to load images', err);
                setError('Failed to load images');
            } finally {
                setLoading(false);
            }
        };

        const loadTotalCount = async () => {
            try {
                const counts = await fetchTotalCount();
                setTotalCount(counts.total);
                setTaggedCount(counts.tagged);
            } catch (err) {
                console.log('Failed to load total count', err);
            }
        };

        loadImages();
        loadTotalCount();
    }, []);

    const handleSearch = (tag: string) => {
        console.log('Searching for tag:', tag);
        setSearchTag(tag);
    };

    const filteredImages = searchTag
        ? images.filter(image => image.tags && image.tags.includes(searchTag))
        : images;

    return (
        <div style={{ minHeight: '100vh', padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
            <div style={{ marginBottom: '24px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h1 style={{ color: '#e0e0e0', margin: 0, fontWeight: 700 }}>Pepe Gallery</h1>
                </div>
                <div style={{ color: '#888', fontSize: '14px', marginTop: '8px' }}>
                    {taggedCount !== null && (
                        <span>{taggedCount.toLocaleString()} tagged & searchable images</span>
                    )}
                </div>
            </div>
            <SearchBar onSearch={handleSearch} />
            {loading ? (
                <p style={{ color: '#888' }}>Loading images...</p>
            ) : error ? (
                <p style={{ color: '#ff6b6b' }}>{error}</p>
            ) : (
                <Gallery tag={searchTag} />
            )}
        </div>
    );
};

export default Home;
